<template>
  <b-modal
    centered
    id="select-update-dialog"
    modal-class="overflow-hidden"
    static
    scrollable
    @hidden="onHidden"
    v-model="showModalUpdate"
  >
    <template #modal-header="{ close }">
      <h5>Cập nhật công việc</h5>
      <b-button size="sm" variant="light" @click="close()"> x </b-button>
    </template>
    <div class="row">
      <div class="wrapper-selected">
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-radio-group v-model="purposesSelected" :aria-describedby="ariaDescribedby">
            <b-form-radio v-for="op in optionsPurpose" :value="op.id" :key="op.id">{{
              op.text
            }}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
    </div>
    <hr />
    <div>
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="status">Trạng thái</label>
            <b-form-select v-model="data.selectedStt" size="sm">
              <option v-for="(item, index) in dataStatus" :key="index" :value="item.id">
                {{ item.text }}
              </option>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="status">Kết quả</label>
            <b-form-select v-model="data.selectedResult" size="sm">
              <option v-for="(item, index) in dataResult" :key="index" :value="item.id">
                {{ item.text }}
              </option>
            </b-form-select>
          </div>
        </div>
      </div>
      <!-- <div class="form-group">
          <label>Thời gian xử lý</label>
          <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateRangeProcessing"
              :locale-data="localeData"
              :timePicker="true"
            :timePicker24Hour="true"

            >
              <template v-slot:input="picker">
                <label v-if="picker.startDate && picker.endDate" style="min-width: 13.5em" class="text-center font-size-12">
                  {{ picker.startDate | formatDate('HH:mm DD/MM/YYYY')  }} - {{ picker.endDate | formatDate('HH:mm DD/MM/YYYY')  }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian
                </label>
              </template>
            </DateRangePicker>
          </div> -->
      <div class="form-group">
        <label>Thời gian xử lý</label>
        <InputRange v-model="dateRangeProcessing"></InputRange>
      </div>
      <div class="form-group">
        <label>Lý do</label>
        <Select2MultipleControl
          v-if="['MC_INACTIVE', 'MC_DECREASE_TPV'].includes(data.noteUpdateType)"
          :settings="{ closeOnSelect: false }"
          v-model="data.noteUpdateArr"
          :options="data.resonArr"
        >
        </Select2MultipleControl>
        <input v-else type="text" class="form-control datetimes" v-model="data.noteUpdate" />
      </div>
      <div class="form-group">
        <label>Mô tả</label>
        <input placeholder="Mô tả" v-model="data.noteDes" />
      </div>
    </div>
    <hr />
    <form class="">
      <div class="form-group img-list">
        <ul class="m-0">
          <UploadMultiple
            @syncFile="syncFile"
            :lsData="fileImage"
            :maxFile="100"
            title="Ảnh giải trình"
            titleTag="h1"
            titleClass="form-inner-heading"
            uniqueKey="images"
          />
        </ul>
      </div>
      <h1 v-if="data.saleOfflineSignedImage" class="form-inner-heading">Ảnh checkin</h1>
      <div class="form-group img-list">
        <ul class="m-0">
          <li v-for="(image, index) in data.saleOfflineSignedImage" :key="index">
            <a href="#popup-slider" data-toggle="modal">
              <img :src="image" alt="" />
            </a>
          </li>
        </ul>
      </div>
    </form>
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="light" @click="cancel()"> Hủy bỏ </b-button>
      <b-button size="sm" variant="primary" @click="updateWork"> Xác nhận </b-button>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </b-modal>
</template>

<script>
  import Config from '@/thirdParty/config'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import { CommonService } from '@/services/common.service'
  import moment from 'moment'
  import InputRange from '@/components/InputRange.vue'
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import mxItemAction from '../mx-item-action'
  import { v4 as uuidv4 } from 'uuid'

  export default {
    components: {
      UploadMultiple,
      InputRange,
    },
    props: {},
    mixins: [mxItemAction],
    data() {
      return {
        data: {},
        showModalUpdate: false,
        selectedStt: '',
        dataStatus: Config.statusCalendarAfs,
        optionsPurpose: [],
        selectedResult: null,
        dataResult: Config.resultCalendarAfs,
        localeData: Config.localeData,
        noteUpdateArr: [],
        noteUpdateType: null,
        noteUpdate: null,
        noteDes: null,
        dataDetail: {},
        fileUploads: [],
        showLoading: false,
        purposesSelected: '',
        fileImage: [],
        dateRangeProcessing: {
          startDate: null,
          endDate: null,
        },
        optionsType: [],
      }
    },
    watch: {},
    methods: {
      syncFile(files) {
        this.fileUploads = files
      },
      async updateWork() {
        const note = ['MC_INACTIVE', 'MC_DECREASE_TPV'].includes(this.data.noteUpdateType)
          ? this.data.noteUpdateArr.join(', ')
          : this.data.noteUpdate
        const files = await Promise.all(this.fileUploads.map(s => this.sendFile(s)))
        const update = {
          id: this.data.id,
          note: note,
          description: this.data.noteDes,
          purposes: [this.purposesSelected],
          result: this.data.selectedResult,
          images: files.map(s => s.urlFile),
          status: this.data.selectedStt,
          saleOfflineSignedImage: this.saleOfflineSignedImage,
          startProcessing: moment(this.dateRangeProcessing.startDate).valueOf(),
          endProcessing: moment(this.dateRangeProcessing.endDate).valueOf(),
        }
        if (note) {
          await this.updateCalendar(update)
        } else this.showFailMx('Lý do k được để trống')
      },
      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', 'NextCrm')
          const data = await CommonService.uploadImg(formData)
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return { urlFile, type: item.type }
        } else return { urlFile: item.url, type: item.type }
      },
      onHidden() {
        this.showModalUpdate = false
        this.resetForm()
      },
      async show(id) {
        this.showModalUpdate = true
        this.resetForm()
        await this.getDetailCalender(id)
      },

      async getDetailCalender(id) {
        try {
          this.showLoading = false
          const res = await CalendarAfsService.getTaskAFSDetailById({ id: id })
          if (res.success && res.code == 1000) {
            await this.calendarUpdate(res.data)
            await this.getOptionType()
            await this.getCatCalendar()
          } else {
            this.showFailMx(res.message)
            this.showModalUpdate = false
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
          this.showModalUpdate = false
        } finally {
          this.showLoading = false
        }
      },

      // cập nhật
      async calendarUpdate(item) {
        this.data = {}
        if (item.handlerRes.userName === this.userData.username) {
          this.onChangeType(item.type)
          this.data.id = item.id
          this.data.selectedStt = item.status
          this.data.selectedResult = item.result
          this.data.noteUpdate = item.note
          this.data.noteUpdateArr = item.note?.split(', ')
          this.data.noteUpdateType = item.type
          this.data.noteDes = item.description
          this.data.saleOfflineSignedImage = item.saleOfflineSignedImage
          this.dateRangeProcessing = {
            startDate: item.startIntend,
            endDate: item.endIntend,
          }
          const mappingData = (arr, type) =>
            arr.forEach(url => {
              const ar = { name: url, url, type, id: uuidv4() }
              this.fileImage.push(ar)
            })
          mappingData(item.images, 'images')
          this.purposesSelected = item.purposes?.[0] ?? null
        } else {
          this.showFailMx('Bạn không có quyền thực hiện thao tác này')
          this.showModalUpdate = false
        }
      },
      async onChangeType(data) {
        const res = mxItemAction.onChangeType(data)
        res.then(result => {
          this.data.resonArr = result
        })
      },
      resetForm() {
        this.fileImage = []
        this.data = {}
        this.purposesSelected = ''
        this.dateRangeProcessing = {}
        this.data.noteUpdateArr = []
        this.optionsType = []
        this.optionsPurpose = []
      },
      async updateCalendar(data) {
        try {
          this.showLoading = true
          const res = await CalendarAfsService.UpdateCalendarAFS(data)
          if (res.success) {
            this.showSuccessMx(res.message)
            this.$emit('updateCalendar')
          } else {
            this.showFailMx(res.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
          this.resetForm()
        }
      },
      async getOptionType() {
        try {
          this.showLoading = true
          const response = await CalendarAfsService.groupCalendar({
            status: 'APPLYING',
            page: 1,
            size: 1000,
          })
          if (response.code && response.code == 1000) {
            this.optionsType = response.data
              ? response.data.reduce((arr, current) => {
                  if (current.groupCode && current.groupName && current.id) {
                    arr.push({ id: current.groupCode, text: current.groupName, mapId: current.id })
                  }
                  return arr
                }, [])
              : []
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      async getCatCalendar() {
        try {
          this.showLoading = true
          const wkGroupId = this.optionsType.find(item => item.id == this.data.noteUpdateType)
          if (!wkGroupId) return

          const response = await CalendarAfsService.catCalendar({
            status: 'APPLYING',
            page: 1,
            size: 1000,
            wkGroupId: wkGroupId ? wkGroupId.mapId : '',
          })
          if (response.code && response.code == 1000) {
            this.optionsPurpose = response.data
              ? response.data.reduce((arr, current) => {
                  if (current.taskCode && current.taskName) {
                    arr.push({ id: current.taskCode, text: current.taskName })
                  }
                  return arr
                }, [])
              : []
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
<style scoped>
  ::v-deep .custom-control-label {
    padding-top: 5px;
  }
</style>
